import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const prefix = "o-accordion";

const Accordion = ({ children, isOpen, title }) => {
  const [isCollapse, setIsCollapse] = useState(isOpen ?? false);
  
  const contentClass = classNames(`${prefix}__content border overflow-y-auto transition-max-height ease-in duration-300 `, {
    "max-h-0": isCollapse,
    "max-h-[200px]": !isCollapse
  });

  return (
    <div className={`${prefix}`}>
      <div
        className={`${prefix}__header flex items-center justify-between bg-gray-100 h-8 px-3 cursor-pointer shadow-sm`}
        onClick={() => setIsCollapse((v) => !v)}
      >{title}</div>
      <div className={contentClass}>{children}</div>
    </div>
  )
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default Accordion;
